module.exports = __webpack_public_path__ + "img/BI.cf790c09.svg";